<script setup lang="ts">
import { createInput } from '@formkit/vue'
import PersonSelector from './CreateInputBase/PersonSelector.vue'

const personSelector = createInput(PersonSelector, { props: ['disabled', 'selectionDisabled', 'hint', 'multiple', 'where', 'hideAddress', 'disablePersonCreation', 'translationKey'] })
</script>

<template>
  <FormKit :type="personSelector" />
</template>
